<template>
  <div class="question-container">
    <span class="questionnaire-info" v-html="question.questionable.data.info"></span>
  </div>
</template>

<script>
export default {
  name: 'InfoQuestion',

  props: {
    question: {
      type: Object,
      default: null
    }
  },

  watch: {
    message (newMessage) {
      this.$emit('updated', newMessage)
    }
  },

  data () {
    return {
      message: null
    }
  }
}
</script>
